module.exports = __webpack_public_path__ + "img/07_sc.cc1e2427.png";